<template>
  <div>
    <officials-list
      title="Lista operatorów"
      :users="list"
      :count="count"
      @add="showAddModal"
      @edit="showEditModal($event.userId)"
      @delete="showDeleteDialog($event.id)"
      @details="goToDetails"
    />

    <modal :show="showModal" :id="idToEdit" :edit="!!idToEdit" @close="hideModal" @save="add" @update="update" />

    <material-dialog
      title="Potwierdź usunięcie"
      :show="!!idToDelete"
      :id="idToDelete"
      :text="confirmDeleteText"
      @close="hideDeleteDialog"
      @confirm="remove"
    />
  </div>
</template>

<script>
import MaterialDialog from '@/components/material/Dialog';
import { listMixin } from '@/mixins/list';
import Modal from './modals/Manage';
import OfficialsList from './subViews/OfficialsList';

/**
 * @vuese
 * @group Officials
 * Lista operatorów
 */
export default {
  components: { MaterialDialog, Modal, OfficialsList },
  mixins: [
    listMixin('officials', {
      listError: 'Wystąpił błąd podczas pobierania listy operatorów.',
      getError: 'Wystąpił błąd podczas pobierania danych operatora.',
      added: 'Dodano operatora.',
      addError: 'Nie udało się dodać operatora.',
      updated: 'Zaktualizowano dane operatora.',
      updateError: 'Nie udało się zaktualizować danych operatora.',
      deleted: 'Usunięto operatora.',
      deleteError: 'Nie udało się usunąć operatora.'
    })
  ],
  computed: {
    toDelete() {
      if (this.idToDelete) {
        return this.list.find(item => item.id === this.idToDelete);
      }
    },
    confirmDeleteText() {
      if (this.toDelete) {
        return `Czy na pewno chcesz usunąć konto operatora ${this.toDelete.firstName} ${this.toDelete.lastName}?`;
      }
      return '';
    }
  },
  methods: {
    goToDetails(profile) {
      this.$router.push({ name: 'official', params: { id: profile.userId } });
    }
  }
};
</script>
